import { fetchTags } from '@/api/v4/tags.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';

export const useTags = () => {
  const query = useQuery({
    queryKey: [QueryKey.Tags],
    queryFn: fetchTags,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    tags: query.data ?? [],
    ...query,
  };
};
